/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  filters.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:28
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import Vue from "vue";
import {moneyFormat} from "@/utils/util";

/**
 * 定义手机号格式为 *** **** ****效果全局过滤器
 */
Vue.filter('mobileFormatter', (value: string) => {
    if (!value) return ''
    return value.replace(/^(.{3})(.*)(.{4})/, '$1 $2 $3')
})

/**
 * 格式化金额为货币格式 123,345
 */
Vue.filter('moneyFormat', (value: string | number) => {
    return moneyFormat(value)
})

/**
 * 格式化银行卡号为 444格式
 */
Vue.filter('bankCardNoFormat', (value: string) => {
    if (!value) return ''
    return value.replace(/(\d{4})(?=\d)/g, '$1 ')
})

/**
 * 取带有小数点数字的整数部分
 */
Vue.filter('amountIntFormat', (value: string | number) => {
    if (!value) return '0'
    return Math.trunc(<number>value)
})

/**
 * 取带有小数点数字的小数部分
 */
Vue.filter('amountFloatFormat', (value: string | number) => {
    if (!value) return '00'
    return String(value).split(".")[1] ? String(value).split(".")[1]: '00'
})



